import axios from "axios";
import { RadioGroup } from "components/Atoms/inputs/RadioGroup";
import { ConnectToGoogle } from "components/externalidentities/Google";
import { Loading } from "components/panels";
import { useValidate } from "formvalidation/hooks";
import React from "react";
import { useCustomQuery } from "utilities/hookutils";

interface Props {
  validatorKey: string;
  selectedCalendarId: string;
  setSelectedCalendarId: (url: string) => void;
  peekGoogleCalendarUrl: string;
  connectToGoogleUrl: string;
  onOutcomeChange?: (outcome: server.dto.ApiResponseWrapper<server.dto.ExternalCalendarPeek>) => void
}

export const SelectGoogleCalendar = (props: Props) => {
  const [isConnectedToGoogle, setIsConnectedToGoogle] = React.useState<boolean>(false);

  const api = useCustomQuery({
    queryFn: () => window.CoreApi.Google.ListCalendars(),
    queryKey: ["myGoogleCalendars"],
    onSuccess: (response) => {
      if (response.data.hasErrors && response.data.errors[0].code === "googleAccessTokenIssue") {
        setIsConnectedToGoogle(false);
      }

      return response.data;
    },
  });

  const googleCalendarValidator = useCustomQuery({
    queryKey: ["googleCalendarValidator", props.selectedCalendarId],
    queryFn: async () => {
      const url = props.peekGoogleCalendarUrl.replace("{id}", encodeURIComponent(props.selectedCalendarId));
      const response = await axios.post<server.dto.ApiResponseWrapper<server.dto.ExternalCalendarPeek>>(url, {
        userId: site.currentUser.userId,
        clientId: site.currentEnvironment.client.clientId,
        calendarId: props.selectedCalendarId,
      }, undefined);
      return response.data;
    },
    enabled: false,
  });

  const validateGoogleCalendar = async (): Promise<string | boolean> => {
    if (props.selectedCalendarId === null) {
      return RESX.GeneralWarnings.InputMandatory;
    }

    const valid = await googleCalendarValidator.refetch();
    if (valid.data.hasErrors) {
      return valid.data.errors[0].message;
    }

    props.onOutcomeChange?.(valid.data);

    return true;
  }

  const validation = useValidate({
    key: props.validatorKey,
    title: RESX.Bookkeeping.Code,
    value: props.selectedCalendarId,
    validate: validateGoogleCalendar,
    ref: null,
    type: "manual"
  });

  const isLoading = api.isLoading;
  const calendars = api.data?.data?.data || [];

  const displayConnectToGoogle = !isConnectedToGoogle && !isLoading && calendars.length === 0;

  return <div>
    {isLoading && <Loading />}
    {displayConnectToGoogle && <div>
      <ConnectToGoogle connectUrl={props.connectToGoogleUrl} />
    </div>}
    {calendars.length > 0 && <RadioGroup
      error={validation.error.hasError}
      orientation="vertical"
      options={calendars.map(c => ({
        label: <div>
          {c.summary}
        </div>,
        value: c.id,
      }))}
      value={props.selectedCalendarId}
      onChange={props.setSelectedCalendarId}
    />}
  </div>
}